import React, { useEffect, useState } from "react";
import PageHeader from "../../../componentsII/PageHeader";
import { useDispatch, useSelector } from "react-redux";
import location from "../../../images/Location.jpg";
import Loader from "../../../componentsII/Loader";
import api from "../../../axios/api";
import { showNotification } from "../../../redux/slices/notificationSlice";
import CustomCardII from "../../../componentsII/CardII";
import { Box, Modal } from "@mui/material";
import { X } from "lucide-react";
import HeatSteamUsageDetailModal from "../../../components/HeatSteamUsage/HeatSteamUsageDetailModal";

const HeatSteamUsage = () => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [heatSteamUsage, setHeatSteamUsage] = useState([]);
  const [companyLocations, setCompanyLocations] = useState([]);
  const [data1, setData1] = useState([]);

  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [detailModalData, setDetailModalData] = useState({});

  const { user } = useSelector((state) => state);
  const year = useSelector((state) => state.user.selectedYear);

  const fetchHeatSteamUsage = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(
        `/consumption/getHeatSteamUsage?company_id=${user.user?.company?.id}&year_id=${year.id}`
      );
      if (response.data.data) {
        setHeatSteamUsage(response.data.data);
      } else {
        dispatch(
          showNotification({
            message: response.data.message,
            type: "error",
          })
        );
        console.log(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsLoading(false);
  };

  const fetchLocations = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(
        `/company/companyLocation?company_id=${user.user.company.id}&year_id=${year.id}`
      );
      if (response.data.data) {
        const activeLocations = response.data.data.filter((location) => location.is_active !== 0);
        
        setCompanyLocations(activeLocations);
      } else {
        showNotification(response.data.message, "error");
        console.log(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsLoading(false);
  };
  
  useEffect(() => {
    fetchHeatSteamUsage();
    fetchLocations();
  }, []);

  // useEffect(() => {
  //   const equipmentIdsToExclude = heatSteamUsage.map(
  //     (entry) => entry?.value
  //   );
  //   const tempData1 = equipmentIdsToExclude?.length
  //     ? companyLocations?.filter(
  //         (entry) => !equipmentIdsToExclude.includes(entry?.id)
  //       )
  //     : companyLocations;
  //   const filteredData = tempData1?.map((item) => {
  //     const value = item?.id
  //     delete item.id
  //     return {
  //      ...item,
  //      value
  //     };
  //   });

  //   setData1(filteredData?.filter((item) => item?.using_heat_steam == "1"));
  // }, [heatSteamUsage?.length, companyLocations?.length]);

  useEffect(() => {
    const locationIdsToExclude = heatSteamUsage.map(entry => entry?.value);
    console.log("IDs to exclude:", locationIdsToExclude);
    
    const tempData1 = locationIdsToExclude?.length
      ? companyLocations?.filter(location => !locationIdsToExclude.includes(location?.id))
      : companyLocations;
    
    
    const filteredData = tempData1?.map(item => {
      const value = item?.id;
      const newItem = {...item};
      delete newItem.id;
      return {
        ...newItem,
        value
      };
    });
  
    setData1(filteredData?.filter(item => item?.using_heat_steam === "1"));
  }, [heatSteamUsage, companyLocations]);

  console.log(companyLocations);

  return (
    <div>
      <PageHeader
        title="Heat & Steam Usage"
        text={[
          "Click into each equipment card in left panel to add your heat and steam usage data",
          "You'll need the type of amount of heat and steam purchased during your reporting period"
        ]}
        buttonTitle=""
        handleClick={() => {}}
      >
         {isLoading ? (
          <div className="w-full h-[200px] flex justify-center items-center">
            <Loader />
          </div>
        ) : (data1.length === 0 && heatSteamUsage.length === 0) ? (
          <div className="text-center py-16 bg-gray-50 rounded-lg">
            <img
              src="/vectors/white isometric factory.jpg"
              alt="No Data"
              className="w-80 h-80 mx-auto text-gray-400 mb-4"
            />
            <h3 className="text-xl font-medium text-gray-600 mb-2">
              No Locations Found
            </h3>
            <p className="text-gray-500">
              Add your first Location to get started
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-0 border rounded-md shadow-md">
            <div className="border-r px-4 bg-red-50 pb-4">
              <div className="p-5 text-xl font-medium">
                <div className="flex items-center">
                  <p className="bg-red-200 w-8 h-8 flex justify-center items-center rounded-full mr-4">
                    {data1?.length}
                  </p>
                  Location(s) need to have data added
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {data1.map((item) => {
                  return (
                    <CustomCardII
                      image={location}
                      title={item?.loc_name}
                      subtitleI={`${item?.address_line_1}`}
                      subtitleII={item?.city_name}
                      clickFun={() => {
                        setIsDetailModalOpen(true);
                        setDetailModalData({ ...item, img:location });
                      }}
                      buttonTitle="+ Add Data"
                      buttonClassName="bg-green-600 hover:bg-green-700 text-white border border-green-500 font-medium w-full text-center flex justify-center hover:-translate-y-0"
                    />
                  );
                })}
              </div>
            </div>
            <div className="px-4 pb-3 bg-green-50">
              <div className="p-5 text-xl font-medium">
                <div className="flex items-center">
                  <p className="bg-green-200 w-8 h-8 flex justify-center items-center rounded-full mr-4">
                    {heatSteamUsage?.length}
                  </p>
                  Done
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {heatSteamUsage.map((item) => {
                  return (
                    <CustomCardII
                      image={location}
                      title={item?.loc_name}
                      subtitleI={`${item?.address_line_1}`}
                      subtitleII={item?.city_name}
                      clickFun={() => {
                        const obj = { ...item, img:location };
                        setIsDetailModalOpen(true);
                        setDetailModalData(obj);
                      }}
                      buttonTitle="Edit Data"
                      buttonClassName="bg-gray-50 hover:bg-gray-100 text-gray-900 border border-gray-900 font-medium w-full text-center flex justify-center hover:-translate-y-0"
                      isEdit={true}
                      emission={item?.co2_emission_tones}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        )}
        <Modal
          open={isDetailModalOpen}
          onClose={() => setIsDetailModalOpen(false)}
          aria-labelledby="add-location-modal-title"
          aria-describedby="add-location-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "55%",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: "8px",
              display: "relative",
            }}
          >
            <button
              onClick={() => setIsDetailModalOpen(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
              aria-label="Close"
            >
              <X size={24} />
            </button>
            <HeatSteamUsageDetailModal
              detailModalData={detailModalData}
              refetch={() => {
                fetchHeatSteamUsage();
                fetchLocations();
              }}
              handleCloseMainDetailModal={() => setIsDetailModalOpen(false)}
            />
          </Box>
        </Modal>
      </PageHeader>
    </div>
  );
};

export default HeatSteamUsage;
